// client/src/axiosConfig.js
import axios from 'axios';

// In prod builds, REACT_APP_* is baked at compile time.
// Put REACT_APP_API_BASE in .env.development only.
const API_BASE = process.env.REACT_APP_API_BASE || '/api';

axios.defaults.baseURL = API_BASE;
axios.defaults.withCredentials = true;

export default axios;